import AutocompleteArrayInputEx from "components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";
import { EmailInput } from "components/inputs/EmailInput";
import { PortInput } from "components/inputs/PortInput";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { HideableOrderFieldChoices } from "entities/HideableOrderField";
import { OrderServiceChoices } from "entities/OrderService";
import { PalletType } from "entities/PalletType";
import React from "react";
import {
	BooleanInput,
	NumberInput,
	ReferenceInput,
	SelectInput,
	TextInput,
	required,
	useTranslate,
} from "react-admin";
import { useFormState } from "react-final-form";

import { FormGroupGrid, GridForm, GridInput } from "../../../components/GridForm";
import { TimeZoneSelect } from "../../../components/inputs/TimeZoneSelect";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import { GroupingPrioritiesInput } from "./components/GroupingPrioritiesInput";

export const TerminalsEditForm = (props) => {
	const { values } = useFormState();
	const translate = useTranslate();
	const byTerminalFilter = { terminal_id: [values["id"]] };
	return (
		<GridForm {...props}>
			<FormGroupGrid>
				<GridInput sm={2} component={TextInput} source="id" disabled />
				<GridInput sm={10} component={TextInput} source="name" validate={[required()]} autoFocus />
				<GridInput sm={7} component={TextInput} source="short_name" validate={[required()]} />
				<GridInput sm={5} component={TextInput} source="account_code" validate={[required()]} />
			</FormGroupGrid>

			<FormGroupGrid>
				<GridInput sm={4} component={TextInput} source="guid" disabled />
				<GridInput sm={4} component={TextInput} source="address" validate={[required()]} />
				<GridInput sm={4} component={TimeZoneSelect} source="time_zone" validate={[required()]} />
				<GridInput
					sm={4}
					component={PortInput}
					source="reception_port"
					filter={byTerminalFilter}
					disableValue={null}
					emptyText=""
					label="resources.terminal.fields.reception_port"
				/>
				<GridInput sm={4} disabled={true}>
					<ReferenceInput source="duty_manager_id" reference="users" disabled={true}>
						<SelectInput optionText={(record) => `${record.first_name} ${record.last_name}`} />
					</ReferenceInput>
				</GridInput>
				<GridInput
					sm={4}
					component={SelectEnumInput}
					source="import_pallet_type"
					enumName="pallet_type"
					enumObj={PalletType}
				/>
				<GridInput
					sm={4}
					component={AutocompleteArrayInputEx}
					choices={OrderServiceChoices}
					source="hidden_service_ids"
				/>
				<GridInput sm={4} component={EmailInput} source="sender_email" />
				<GridInput
					sm={4}
					component={YesNoInput}
					source="should_generate_gtin"
					defaultValue={true}
				/>
				<GridInput
					sm={4}
					component={YesNoInput}
					source="should_create_pallets_from_packing_list_doc"
					defaultValue={false}
				/>
				<GridInput
					sm={4}
					component={BooleanInput}
					source="should_process_splitted_pallets"
					defaultValue={false}
				/>
				<GridInput
					sm={4}
					component={YesNoInput}
					source="is_pallet_stacking_allowed"
					defaultValue={false}
				/>
				<GridInput
					sm={4}
					component={YesNoInput}
					source="should_use_storage_module"
					defaultValue={true}
				/>
				<GridInput
					sm={8}
					component={AutocompleteArrayInputEx}
					choices={HideableOrderFieldChoices}
					source="hidden_order_fields"
				/>
				<GridInput sm={4} component={NumberInput} source="high_level_place_from" min={1} />
			</FormGroupGrid>

			<FormGroupGrid title={translate("resources.terminal.grouping_priorities.title")}>
				<GridInput xs={12}>
					<GroupingPrioritiesInput />
				</GridInput>
			</FormGroupGrid>
		</GridForm>
	);
};
